import withLayout from 'apps/web-client/src/hoc/with-layout';
import React from 'react';

import AddGroupController from './add-group.controller';

const AddGroupScreen: React.FC = () => {
  return <AddGroupController />;
};
export default withLayout(AddGroupScreen);
